import { createAction, createReducer } from 'redux-starter-kit'
import { createSelector } from 'reselect'

import { RESET_ALL_REPORTS } from '../reportsRedux'

const SET_REPORT_PEARY_CONTEXT = '[reports] set report peary context'
const CLEAR_REPORT_PEARY_CONTEXT = '[reports] clear report peary context'

const initialState = {
  contextId: null,
  reportType: null,
  filterFingerprint: null,
  updatedAt: null,
}

export const setReportPearyContextAction = createAction(
  SET_REPORT_PEARY_CONTEXT
)
export const clearReportPearyContextAction = createAction(
  CLEAR_REPORT_PEARY_CONTEXT
)

export const reportPearyContextReducer = createReducer(initialState, {
  [SET_REPORT_PEARY_CONTEXT]: (state, { payload }) => ({
    ...state,
    ...payload,
  }),
  [CLEAR_REPORT_PEARY_CONTEXT]: () => ({ ...initialState }),
  [RESET_ALL_REPORTS]: () => ({ ...initialState }),
})

const stateSelector = (state) =>
  state.reportReducer?.reportPearyContextReducer || initialState

export const reportPearyContextSelector = createSelector(
  stateSelector,
  (context) => context
)

export const reportPearyContextIdSelector = createSelector(
  stateSelector,
  (context) => context.contextId
)
